import { Constants } from '@app/common/constants';
import { AuthGuard } from '@app/guards/auth.guard';
import { CollaborationComponent } from '@app/views/collaboration/collaboration.component';
import { FindInformationComponent } from '@app/views/find-information/find-information.component';
import { MyBoardComponent } from '@app/views/my-board/my-board.component';
import { TodayComponent } from '@app/views/today/today.component';
import { Roles } from '@app/common/roles';
import { AuthorizeAccessGuard } from '@app/guards/authorize-access.guard';
import { Route } from '@angular/router';
import { LicenseGuard } from '@app/guards/license.guard';
import { TodayLightComponent } from 'projects/workplace-light/src/app/today-light/today-light.component';
import { FindInformationLightComponent } from '@app/views/find-information-light/find-information-light.component';

export namespace DefaultRoutes {
  export const TODAY_LIGHT: Route = {
    path: 'light', component: TodayLightComponent, canActivate: [AuthGuard], data: Constants.TODAY_LIGHT_DEFAULT_DATA
  };
  export const FIND_INFO_LIGHT: Route = {
    path: 'find-information-light', component: FindInformationLightComponent, canActivate: [AuthGuard], data: Constants.FIND_LIGHT_INFO_DEFAULT_DATA
  };
  export const TODAY: Route = {
    path: '', component: TodayComponent, canActivate: [AuthGuard], data: Constants.TODAY_DEFAULT_DATA
  };
  export const TODAY_WITH_LICENSE_CHECK: Route = {
    ...TODAY, ...{ canActivate: [AuthGuard, LicenseGuard] }
  };
  export const YOUR_BOARD: Route = {
    path: 'your-board', component: MyBoardComponent, canActivate: [AuthGuard], data: Constants.YOUR_BOARD_DEFAULT_DATA
  };
  export const YOUR_BOARD_WITH_LICENSE_CHECK: Route = {
    ...YOUR_BOARD, ...{ canActivate: [AuthGuard, LicenseGuard] }
  };
  export const COLLABORATION: Route = {
    path: 'collaboration', component: CollaborationComponent, canActivate: [AuthGuard], data: Constants.COLLABORATION_DEFAULT_DATA
  };
  export const COLLABORATION_WITH_LICENSE_CHECK: Route = {
    ...COLLABORATION, ...{ canActivate: [AuthGuard, LicenseGuard] }
  };
  export const FIND_INFO: Route = {
    path: 'find-information', component: FindInformationComponent, canActivate: [AuthGuard], data: Constants.FIND_INFO_DEFAULT_DATA
  };
  export const FIND_INFO_WITH_LICENSE_CHECK: Route = {
    ...FIND_INFO, ...{ canActivate: [AuthGuard, LicenseGuard] }
  };
  export const APPS_TOOLS: Route = {
    path: 'apps-and-tools', loadChildren: () => import('@app/views/apps-and-tools/apps-and-tools-view.module').then(m => m.AppsAndToolsViewModule), canActivate: [AuthGuard],
    data: Constants.APP_CENTER_DEFAULT_DATA
  };
  export const SETTINGS: Route = {
    path: 'settings', loadChildren: () => import('@app/views/settings/settings-view.module').then(m => m.SettingsViewModule), canActivate: [AuthGuard],
    data: Constants.SETTINGS_DEFAULT_DATA
  };
  export const CREATE_SITE: Route = {
    path: 'create-site', loadChildren: () => import('@app/views/create-site/create-site-view.module').then(m => m.CreateSiteViewModule), canActivate: [AuthorizeAccessGuard, LicenseGuard],
    data: Constants.CREATE_SITE_DEFAULT_DATA
  };
  export const EDITOR_DASHBOARD: Route = {
    path: 'editor-dashboard', loadChildren: () => import('@app/views/editor-dashboard/editor-dashboard-view.module').then(m => m.EditorDashboardViewModule), canActivate: [AuthorizeAccessGuard],
    data: Constants.EDITOR_DASHBOARD_DEFAULT_DATA
  };
  export const FIRST_DAY: Route = {
    path: 'first-day', loadChildren: () => import('@app/views/first-day-wizard/first-day-view.module').then(m => m.FirstDayViewModule), canActivate: [AuthGuard],
    data: Constants.FIRST_DAY_DEFAULT_DATA
  };
  export const ADMIN: Route = {
    path: 'admin', loadChildren: () => import('@app/views/admin/admin-view.module').then(m => m.AdminViewModule), canActivate: [AuthorizeAccessGuard],
    data: Constants.ADMIN_DASHBOARD_DEFAULT_DATA
  };
  export const ABOUT: Route = {
    path: 'about', loadChildren: () => import('@app/views/about/about-view.module').then(m => m.AboutViewModule), canActivate: [AuthorizeAccessGuard],
    data: { roles: [Roles.Admin] }
  };
  export const PEOPLE: Route = {
    path: 'people', loadChildren: () => import('@app/views/find-colleague/find-colleague-view.module').then(m => m.FindColleagueViewModule), canActivate: [AuthGuard],
    data: Constants.FIND_COLLEAGUE_DEFAULT_DATA
  };
  export const BROADCAST_MESSAGES: Route = {
    path: 'broadcast-messages', loadChildren: () => import('@app/views/broadcast-messages/broadcast-messages-view.module').then(m => m.BroadcastMessagesViewModule), canActivate: [AuthorizeAccessGuard],
    data: Constants.BROADCAST_MESSAGES_DEFAULT_DATA
  };
  export const RESTAURANT: Route = {
    path: 'restaurant-menus', loadChildren: () => import('@app/views/restaurant-menu/restaurant-menu-view.module').then(m => m.RestaurantMenuViewModule), canActivate: [AuthorizeAccessGuard],
    data: Constants.RESTAURANT_DEFAULT_DATA
  };
  export const KPI_CHARTS: Route = {
    path: 'kpi-charts', loadChildren: () => import('@app/views/kpi-charts/kpi-charts-view.module').then(m => m.KpiChartsViewModule), canActivate: [AuthorizeAccessGuard],
    data: Constants.KPI_CHARTS_DEFAULT_DATA
  };
  export const MSTEAMS_AUTH: Route = {
    path: 'msteams-auth', outlet: 'auth', loadChildren: () => import('@app/views/msteams-auth/msteams-auth-view.module').then(m => m.MsteamsAuthViewModule)
  };
  export const PAGES: Route = {
    path: 'pages', loadChildren: () => import('@app/views/pages/pages-view.module').then(m => m.PagesViewModule), canActivate: [AuthGuard],
    data: Constants.PAGES_DEFAULT_DATA
  };
  export const INFOBOXES: Route = {
    path: 'infoboxes', loadChildren: () => import('@app/views/infobox/infobox-view.module').then(m => m.InfoBoxViewModule), canActivate: [AuthorizeAccessGuard],
    data: Constants.INFOBOXES_DEFAULT_DATA
  };
  export const USER: Route = {
    // this needs a specific license to be allowed to run
    path: 'user', loadChildren: () => import('@app/views/user/user-view.module').then(m => m.UserViewModule), canActivate: [AuthGuard], data: Constants.MY_PROFILE_DEFAULT_DATA
  };
  export const POWER_BI: Route = {
    path: 'power-bi', loadChildren: () => import('@app/views/power-bi/power-bi-frames-view.module').then(m => m.PowerBIFramesViewModule), canActivate: [AuthorizeAccessGuard],
    data: Constants.POWER_BI_DEFAULT_DATA
  };
}
